import { useEffect, useState } from "react";
import type { ThreadManagement } from "@afar-research/contracts";

/** Reclassify only at the nearest snooze deadline; timers never drive the whole list each second. */
export function useThreadSnoozeClock(
  threads: readonly { management?: ThreadManagement | null | undefined }[],
) {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const current = Date.now();
    const next = Math.min(
      ...threads.flatMap((thread) => {
        const until = Date.parse(thread.management?.snoozedUntil ?? "");
        return until > current ? [until] : [];
      }),
    );
    const refresh = () => setNow(Date.now());
    const timer = Number.isFinite(next)
      ? setTimeout(refresh, Math.min(next - current + 1, 2_147_483_647))
      : undefined;
    window.addEventListener("focus", refresh);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("focus", refresh);
    };
  }, [threads, now]);
  return Math.max(now, Date.now());
}
